const filterBar = document.querySelector('#main-collection-filters');

let headerHeight = document.querySelector('.header').offsetHeight;
let filterBarOffsetTop;
let filterBarHeight;

if(filterBar) {
    filterBarOffsetTop = filterBar.offsetTop;
    filterBarHeight = filterBar.offsetHeight;
}

if (!headerHeight){
    headerHeight = 0;
}

function updatefilterBarOffsetTop() {
  filterBarOffsetTop = filterBar.offsetTop;
  filterBarHeight = filterBar.offsetHeight;
};

function pinElement() {
    filterBar.classList.remove('filter-fixed');
    document.body.style.paddingTop = 0;
  
    if (window.scrollY >= filterBarOffsetTop) {
        document.body.style.paddingTop = `${filterBarHeight}px`;
        filterBar.classList.add('filter-fixed');
    }

    if (this.oldScroll > this.scrollY) {
        filterBar.style.top = `${headerHeight}px`;
    }
    else {
        filterBar.style.top = 0;
    }
    this.oldScroll = this.scrollY;

};

if(filterBar) {
    window.addEventListener('resize', updatefilterBarOffsetTop);
    window.addEventListener('scroll', pinElement);
}